if (!theme.settings.enableWishlist) return;

import './components/wishlist';
import './components/wishlistButton';
import './components/wishlistPage';
